import {useTranslation} from 'react-i18next';
import {ArrowRight} from 'lucide-react';
import {Button, cn} from '@chekinapp/ui';

type SeeAllLinkProps = {
  onClick: () => void;
  className?: string;
};

export function SeeAllLink({onClick, className}: SeeAllLinkProps) {
  const {t} = useTranslation();

  return (
    <Button
      variant="link"
      onClick={onClick}
      className={cn(
        'shrink-0 gap-1 hover:underline hover:opacity-100 [&_svg]:size-[13px]',
        className,
      )}
    >
      {t('see_all')}
      <ArrowRight />
    </Button>
  );
}
